import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section id="reframe" className="relative pt-8 pb-12 md:pt-12 md:pb-16 px-6 md:px-8 bg-cream overflow-hidden" data-id="element-332">
      <div className="max-w-2xl mx-auto text-center" data-id="element-333">
        {/* Decorative accent */}
        <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} whileInView={{
        opacity: 1,
        scaleX: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="w-12 h-px bg-terracotta/40 mx-auto mb-10" data-id="element-334" />

        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="font-serif text-2xl md:text-4xl text-brown leading-snug mb-5" data-id="element-335">
          The problem isn't your baby.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        delay: 0.1,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="text-base md:text-lg text-brown-light/80 leading-relaxed mb-10 max-w-xl mx-auto" data-id="element-336">
          Contact naps are developmentally normal.
          <br className="hidden md:block" data-id="element-337" />
          What's missing is a system built around{' '}
          <span className="text-brown font-medium" data-id="element-338">you</span>.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="font-serif text-xl md:text-2xl text-terracotta/90 italic leading-relaxed" data-id="element-339">
          "You don't need perfect naps.
          <br className="hidden md:block" data-id="element-340" />
          You need 30 protected minutes."
        </motion.p>
      </div>
    </section>;
}